import { Expose, Type } from 'class-transformer';
import { SurveyElement } from '@/models/survey-elements';
import { SurveyElementsUnion } from '@/models//survey-elements-union';
import { DiscriminatorConfig } from '@/models/survey-elements/survey-element-discriminator';

export class SurveyGroupingElement extends SurveyElement {
  @Type(() => SurveyElement, {
    discriminator: {
      property: 'element_type',
      subTypes: DiscriminatorConfig(),
    },
    keepDiscriminatorProperty: true,
  })
  elements!: SurveyElementsUnion[];

  outlined?: boolean;
}
